import { router, useLocalSearchParams } from 'expo-router';
import { useAtomValue } from 'jotai';
import { TabPanel, TabView } from 'primereact/tabview';
import React from 'react';
import { BodySmallEmphasized } from 'smoothie';

import { FullPageContainer } from '../../common/components/GroveContainers';
import { adminUserAtom } from '../../entities/entityAtoms';
import { BankOpsApyRatesPanel } from './BankOpsApyRates';
import { BankOpsDirectDepositPanel } from './BankOpsDirectDeposit';
import { BankOpsDirectDepositRewardsPanel } from './BankOpsDirectDepositRewards';
import { BankOpsExternalAccountReviewPanel } from './BankOpsExternalAccountReviewPanel';
import { BankOpsInterestPanel } from './BankOpsInterest';
import { BankOpsReferralsPanel } from './BankOpsReferralsPanel';
import { BankOpsRewardsPanel } from './BankOpsRewards';
import { BankOpsStatementsPanel } from './BankOpsStatements';

const BankOpsPage = () => {
    const adminUser = useAtomValue(adminUserAtom);
    const { dt: selectedTabIndex } = useLocalSearchParams<{ dt: string }>();

    if (!adminUser.authorization.bankOpsFunctionality.canUse) {
        return (
            <BodySmallEmphasized color="$red1100" marginVertical="auto">
                No access to Fruitful Bank Operations
            </BodySmallEmphasized>
        );
    }

    const selectedTabIndexNum = parseInt(selectedTabIndex, 10) || 0;

    return (
        <FullPageContainer>
            <TabView
                style={{ width: '100%', marginTop: '-0.5vw' }}
                panelContainerStyle={{
                    width: '100%',
                    padding: 0,
                    marginTop: 32,
                }}
                activeIndex={selectedTabIndexNum}
                onTabChange={(e) => {
                    router.setParams({ dt: e.index.toString() });
                }}
            >
                <TabPanel header="Direct Deposit">
                    <BankOpsDirectDepositPanel />
                </TabPanel>
                <TabPanel header="Cash Back">
                    <BankOpsRewardsPanel />
                </TabPanel>
                <TabPanel header="DD Bonus">
                    <BankOpsDirectDepositRewardsPanel />
                </TabPanel>
                <TabPanel header="Referrals">
                    <BankOpsReferralsPanel />
                </TabPanel>
                <TabPanel header="Statements">
                    <BankOpsStatementsPanel />
                </TabPanel>
                <TabPanel header="Interest">
                    <BankOpsInterestPanel />
                </TabPanel>
                <TabPanel header="APY Rates">
                    <BankOpsApyRatesPanel />
                </TabPanel>
                <TabPanel header="External Account Review">
                    <BankOpsExternalAccountReviewPanel />
                </TabPanel>
            </TabView>
        </FullPageContainer>
    );
};

export default BankOpsPage;
